import React, { useState } from 'react';
import styled from 'styled-components';
import ContactModal from '../shared/ContactModal';

const EmailSignupSection = () => {
  const [email, setEmail] = useState("");
  const [isAdult, setIsAdult] = useState(false);
  const [contactMe, setContactMe] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success', 'error', or null
  const [showContactModal, setShowContactModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !isAdult) return;

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Call backend API to add subscriber to Mailchimp
      const response = await fetch('/.netlify/functions/addEmailSubscriber', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          tags: contactMe ? ['bela-newsletter', 'partnerships-interested'] : ['bela-newsletter'],
          source: 'email-signup-section'
        })
      });      if (response.ok) {
        setSubmitStatus('success');
        setEmail("");
        setIsAdult(false);
        setContactMe(false);
        
        // Open contact modal after successful email submission
        setTimeout(() => {
          setSubmitStatus(null);
          setShowContactModal(true);
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error submitting email:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Wrapper id="email-signup">
      <MainTitle>Stay in the loop</MainTitle>
      <Content>
        <TextContent>
          <Title>Parents & Educators (18+) only.</Title>
          <Description>
            Get B.E.L.A. launch news and free classroom resources that turn story into simple real-world actions.<br />
            • Short updates about B.E.L.A. milestones <br />
            • Printable activities & discussion guides <br />
            • Opportunities to pilot projects
          </Description>
        </TextContent>
        <FormContainer>
          <Form onSubmit={handleSubmit}>
            <InputRow>
              <EmailInput
                type="email"
                placeholder="Enter email address"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
              <SubmitButton type="submit" disabled={!isAdult || isSubmitting}>
                {isSubmitting ? 'Submitting...' : 'Continue'}
              </SubmitButton>
            </InputRow>
            <CheckboxLabel>
              <Checkbox
                checked={isAdult}
                onChange={e => setIsAdult(e.target.checked)}
                required
              />
              I confirm I am 18 or older.
            </CheckboxLabel>
            <CheckboxLabel>
              <Checkbox
                checked={contactMe}
                onChange={e => setContactMe(e.target.checked)}
              />
              Contact me about partnerships/media.
            </CheckboxLabel>            {submitStatus === 'success' && (
              <SuccessMessage>✓ Thank you! You've been added to our mailing list. Please fill out the contact form that will open shortly.</SuccessMessage>
            )}
            {submitStatus === 'error' && (
              <ErrorMessage>✕ Something went wrong. Please try again.</ErrorMessage>
            )}
          </Form>
        </FormContainer>
      </Content>      <Microcopy>
        <i>We never collect personal information from children. Unsubscribe anytime.</i>
      </Microcopy>
      
      <ContactModal 
        isOpen={showContactModal} 
        onClose={() => setShowContactModal(false)}
        onSubmitSuccess={() => setShowContactModal(false)}
      />
    </Wrapper>
  );
};

const Wrapper = styled.section`
  width: 100vw;
  background: linear-gradient(120deg, #eaf1fb 0%, #e3eafc 40%, #dbeafe 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  padding: 50px 0;
  @media (max-width: 768px) {
    padding: 0;
  }
`;

const MainTitle = styled.h2`
  font-size: 2.8rem;
  font-weight: 900;
  line-height: 1.1;
  margin: 0 0 25px 0;
  background: linear-gradient(90deg, #1e3a8a 0%, #2563eb 60%, #60a5fa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  text-align: center;
  @media (max-width: 1024px) {
    font-size: 1.7rem;
  }
  @media (max-width: 600px) {
    font-size: 1.1rem;
  }
`;

const Content = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 0 0 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 30px;

  @media (max-width: 1024px) {
    gap: 26px;
    padding: 10px 20px 0 20px;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 24px;
  }

  @media (max-width: 768px) {
    padding: 10px 16px 0 16px;
    gap: 22px;
  }

  @media (max-width: 640px) {
    padding: 10px 14px 0 14px;
    gap: 20px;
  }

  @media (max-width: 480px) {
    padding: 10px 12px 0 12px;
    gap: 18px;
  }
`;

const TextContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 500px;
`;

const Title = styled.h3`
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0;
  color: #2563eb;
  text-align: left;
  @media (max-width: 768px) {
  text-align: center;
  }
`;

const Description = styled.p`
  font-size: 1.1rem;
  color: #334155;
  font-weight: 400;
  margin-bottom: 18px;
  line-height: 1.7;
  margin: 0 auto 18px auto;
  max-width: 700px;
  text-align: left;
  @media (max-width: 768px) {
  text-align: center;
  }
`;

const FormContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  justify-content: flex-end;
  
  @media (max-width: 1024px) {
    gap: 12px;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 13px;
  align-self: flex-end;
  justify-content: flex-end;
  width: 100%;
`;

const InputRow = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  width: 100%;
  margin-bottom: 8px;

  @media (max-width: 600px) {
    max-width: 100%;
  }
`;

const EmailInput = styled.input`
  flex: 1;
  padding: 14px 16px;
  border: none;
  font-size: 1rem;
  outline: none;
  background: transparent;
  color: #222;

  &::placeholder {
    color: #888;
    font-weight: 400;
  }
  
  @media (max-width: 1024px) {
    font-size: 0.75rem;
    padding: 10px 12px;
  }
`;

const SubmitButton = styled.button`
  background: #3b82f6;
  color: #fff;
  border: none;
  border-radius: 0 8px 8px 0;
  padding: 14px 32px;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  cursor: pointer;
  transition: background 0.2s, opacity 0.2s;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${props => props.disabled ? 0.5 : 1};
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};

  &:hover {
    background:#1770ff 54.50%);
  }
  
  @media (max-width: 1024px) {
    font-size: 0.75rem;
    padding: 10px 26px;
  }
`;

const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid #3b82f6;
  border-radius: 6px;
  background: #fff;
  margin-right: 8px;
  transition: border 0.2s, box-shadow 0.2s;
  position: relative;
  cursor: pointer;
  outline: none;

  &:checked {
    background: #1770ff;
    border-color:#2274f7;
  }
  &:checked:after {
    content: '';
    position: absolute;
    left: 6px;
    top: 2px;
    width: 6px;
    height: 12px;
    border: solid #fff;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
    display: block;
  }
  &:focus {
    box-shadow: 0 0 0 2px#2676f6;
  }
  
  @media (max-width: 1024px) {
    width: 14px;
    height: 14px;
    border: 1px solid #3b82f6;
  }
  @media (max-width: 768px) {
    width: 12px;
    height: 12px;
  }
`;

const CheckboxLabel = styled.label`
  font-size: 1rem;
  color: #000;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  
  @media (max-width: 1024px) {
    font-size: 0.9rem;
    gap: 6px;
  }
`;

const Microcopy = styled.p`
  font-size: 0.95rem;
  color: #000;
  margin-top: 25px;
  text-align: center;
  
  @media (max-width: 1024px) {
    font-size: 0.85rem;
  }
`;

const SuccessMessage = styled.div`
  color: #10b981;
  font-size: 0.9rem;
  font-weight: 500;
  text-align: center;
  animation: slideDown 0.3s ease-out;
  
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const ErrorMessage = styled.div`
  color: #ef4444;
  font-size: 0.9rem;
  font-weight: 500;
  text-align: center;
  animation: slideDown 0.3s ease-out;
  
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export default EmailSignupSection;
